// @flow

import * as React from 'react';
import PropTypes from 'prop-types';
import type ExperimentsClient from 'app/common/lib/ExperimentsClient';
import type { PinType } from 'app/common/react/components/growth/unauth/lib/PropTypes';
import { ExperimentsPropType } from 'app/common/lib/react/withUnauthSeoExperiments';
import {
  calculateDescriptionNumLines,
  shouldRenderAttributionTitle,
} from 'app/common/react/components/growth/unauth/pin/pinUtils';

type Props = {
  seoUnauthExperiments: ExperimentsClient,
  description: string,
  pin: PinType,
  isCloseUp?: boolean,
  inPinGridOptGroup?: boolean,
  showVaseCarousel?: React.Node,
  richPinAttribution: React.Node,
  richRecipeAttribution: React.Node,
};

const styles = {
  description: {
    color: '#333',
    fontSize: 13,
    lineHeight: '17px',
    margin: '5px 0',
    MozOsxFontSmoothing: 'grayscale',
    padding: '0px',
    textAlign: 'left',
    WebkitFontSmoothing: 'antialiased',
    wordWrap: 'break-word',
  },
  descriptionCloseUp: {
    color: '#333',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: '17px',
    margin: '5px 0',
    padding: '0px',
    textAlign: 'left',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    wordWrap: 'break-word',
  },
};

export const PinDescriptionContainer = (props: Props) => {
  const {
    seoUnauthExperiments,
    description,
    pin,
    richPinAttribution,
    richRecipeAttribution,
    inPinGridOptGroup = false,
    showVaseCarousel = null,
  } = props;

  const numLinesForDescription = calculateDescriptionNumLines(description, seoUnauthExperiments);

  const style = styles.description;

  if (shouldRenderAttributionTitle(pin)) {
    return (
      <React.Fragment>
        {inPinGridOptGroup && richPinAttribution}
        {inPinGridOptGroup && richRecipeAttribution}
        {inPinGridOptGroup && showVaseCarousel}
        <p
          className={'PinDescription__desc PinDescription__' + numLinesForDescription + 'LineDesc'}
          data-test-id="desc"
          key="pin-description"
          style={inPinGridOptGroup ? null : style}
        >
          {description}
        </p>
      </React.Fragment>
    );
  } else {
    return inPinGridOptGroup ? (
      showVaseCarousel
    ) : (
      <h3
        className={'PinDescription__desc PinDescription__' + numLinesForDescription + 'LineDesc'}
        data-test-id="desc"
        style={style}
      >
        {description}
      </h3>
    );
  }
};

PinDescriptionContainer.propTypes = {
  description: PropTypes.string,
  isCloseUp: PropTypes.bool,
  inPinGridOptGroup: PropTypes.bool,
  pin: PropTypes.shape({}),
  seoUnauthExperiments: ExperimentsPropType,
  showVaseCarousel: PropTypes.node,
  richPinAttribution: PropTypes.node,
  richRecipeAttribution: PropTypes.node,
};

export default PinDescriptionContainer;
